import getUserLocale from "get-user-locale";

const userLocale = getUserLocale();
let lang: Languages = 'en';
if (userLocale === 'pt-BR' || userLocale === 'pt' || userLocale === 'br') lang = 'pt'
else if (userLocale === 'es') lang = 'es';
else if (userLocale === 'fr') lang = 'fr';
else if (userLocale === 'it') lang = 'it';
else if (userLocale === 'pl') lang = 'pl';
//add polish


type Languages = 'en' | 'fr' | 'es' | 'pt' | 'it' | 'pl';
type Locale = {
    start: string;
    city: string;
    country: string;
    styles: string;
    address: string;
    loadMore: string;
    refresh: string;
    update: string;
    interests: {
        header: string;
        select: string
    };
    youLiked: string;
    sendFriendRequest: string,
    cancelFriendRequest: string,
    acceptFriendRequest: string,
    declineFriendRequest: string,
    removeFriend: string,
    pageTitle: string,
    emailPlaceholder: string,
    passwordPlaceholder: string,
    communityHeader: string,
    createCommunityHeader: string,
    chooseImage: string,
    changeImage: string,
    titleLabel: string,
    descriptionLabel: string,
    countryLabel: string,
    cityLabel: string,
    submitButton: string,
    latestCommunitiesHeader: string,
    noCommunitiesMessage: string,
    createCommunityPrompt: string,
    newCommunityButton: string,
    calendarHeader: string,
    calendarDescription: string,
    loadingMessage: string,
    signUpPageTitle: string,
    signInPrompt: string,
    secureAccountPrompt: string,
    passwordLengthRequirement: string,
    passwordUpperLowerRequirement: string,
    passwordNumberRequirement: string,
    passwordSpecialCharRequirement: string,
    acceptPoliciesPrompt: string,
    previousButton: string,
    nextButton: string,
    resetPasswordPageTitle: string,
    signUpButtonText: string,
    signInButtonText: string,
    signInWithGoogleButtonText: string,
    signUpWithGoogleButtonText: string,
    signInwithAppleButtonText: string,
    signUpWithAppleButtonText: string,
    loginButtonText: string,
    loginInsteadText: string,
    resetPasswordButtonText: string,
    resetPasswordPrompt: string,
    namePlaceholder: string,
    countryPlaceholder: string,
    cityPlaceholder: string,
    peopleDancingAlt: string,
    fillRequiredFields: string,
    weakPassword: string,
    resetPassworPageTitle: string,
    refrainFromProfanity: string,
    communityEdit: string,
    eventEdit: string
    title: string,
    description: string,
    appTitle: string,
    appDescription: string,
    errorPageMessage: string,
    page404Message: string,
    sorry: string,
    home: string,
    retry: string,
    back: string,
    block: string,
    unblock: string,
    sureQuestion: string,
    message: {
        noMessages: string;
        header: string,
        message: string
    },
    skip: string,
    next: string,
    clearAll: string,
    myName: string,
    unfollow: string,
    follow: string,
    send: string,
    resultsWillBeShownHere: string,
    notifications: {
        header: string,
        youNeedToBeLoggedIn: string,
        noNotifications: string
    },
    post: {
        latest: string,
        posts: string,
        post: string,
        leaveComment: string,
        comment: string,
        comments: string
    },
    event: {
        email: string;
        duration: string;
        startTime: string;
        endTime: string;
        endDate: string;
        startDate: string;
        recurringEvent: string;
        chooseAtLeastOneStyle: string;
        whoIsGoing: string;
        eventBy: string;
        entryType: string;
        notFound: string;
        event: string;
        recurringWeekly: string;
        recurringMonthly: string;
        recurringDaily: string;
        deletePrompt: string;
        flagPrompt: string;
        createYourOwn: string;
        latestEvents: string;
        create: string;
        noEventsYetCreate: string;
        myEvents: string;
        events: string;
        likedEvents: string;
        matching: string,
        noEventsFound: string,
    },
    profile: {
        bio: string;
        name: string;
        mobile: string;
        email: string;
        profileType: string;
        logout: string;
        deleteAccount: string;
        noPendingReceived: string;
        requestsReceived: string;
        noPendingSent: string;
        requestSent: string;
        noFriends: string;
        friends: string;
        peopleYouMightKnow: string;
        noAccessUid: string;
        noAccess: string;
        myProfile: string;
        dancer: string;
        teacher: string;
        performer: string;
        organiser: string;
        musician: string;

        uploadImageConfirmation: string;
        deleteAccountConfirmation: string;
        notFound: string,
        loading: string,
        user: string
    },
    onboarding: {
        slide1: {
            title: string,
            description: string
        },
        slide2: {
            title: string,
            description: string
        },
        slide3: {
            title: string,
            description: string
        },
        slide4: {
            title: string,
            description: string
        },
        slide5: {
            title: string,
            description: string
        },
    },
}

const texts: { [key in Languages]: Locale } = {
    en: {
        appTitle: "Step it!",
        appDescription: "Your dancing community builder",
        errorPageMessage: "Oops! Something happened while loading this page. Try again later or click on the home button.",
        page404Message: "The page you are looking for does not exist. Click on the home button to go back to the main page.",
        title: "Title",
        loadMore: "Load More...",
        description: "Description",
        start: "Start",
        city: "City",
        country: "Country",
        styles: "Styles",
        address: "Address",
        message: {
            message: "Message",
            header: "Messages",
            noMessages: "No messages"
        },
        back: "Back",
        retry: "Retry",
        sureQuestion: "Are you sure you want to",
        home: "Home",
        myName: "My Name",
        sorry: "Sorry!",
        block: "Block",
        unblock: "Unblock",
        update: "Update",
        follow: "Follow",
        unfollow: "Unfollow",
        eventEdit: "Edit Event",
        signInButtonText: "Sign in",
        sendFriendRequest: "Add Friend",
        cancelFriendRequest: "Cancel Request",
        acceptFriendRequest: "Accept Request",
        declineFriendRequest: "Decline Request",
        removeFriend: "Remove Friend",
        pageTitle: 'Sign in',
        refresh: "Refresh",
        clearAll: "Clear All",
        send: "Send",
        skip: "Skip",
        next: "Next",
        youLiked: "You liked",
        emailPlaceholder: 'Email',
        passwordPlaceholder: 'Password',
        resultsWillBeShownHere: "The results will be shown here...",
        profile: {
            name: "Name",
            mobile: "Mobile",
            bio: "Bio",
            email: "Email",
            profileType: "Profile Type",
            logout: "Logout",
            deleteAccount: "Delete Account",
            myProfile: "My Profile",
            friends: "Friends",
            noFriends: "You have no friends yet",
            requestsReceived: "Friend Requests Received",
            requestSent: "Friend Requests Sent",
            peopleYouMightKnow: "People you might know",
            noPendingSent: "No pending friend requests sent",
            noPendingReceived: "No pending friend requests received",
            noAccess: "Cannot access this profile!",
            noAccessUid: "Cannot find profile: Issue with uid",
            dancer: "Dancer",
            teacher: "Teacher",
            performer: "Performer",
            organiser: "Organiser",
            musician: "Musician",
            notFound: "Cannot find profile: Issue with uid",
            loading: "Loading Profile...",
            user: "User",
            deleteAccountConfirmation: "Are you sure you want to delete your account? This action cannot be undone.",
            uploadImageConfirmation: "Would you like to update your profile image?"
        },
        interests: {
            select: "Select your interests to match you with relevant events.",
            header: "Interests"
        },
        notifications: {
            header: "Notifications",
            youNeedToBeLoggedIn: "You need to be logged in to view your notifications!",
            noNotifications: "There are no notifications!"
        },
        post: {
            latest: "Latest Posts",
            posts: "Posts",
            leaveComment: "Leave a comment",
            comment: "Comment",
            comments: "Comments",
            post: "Post"
        },
        event: {
            myEvents: "My Events",
            events: "Events",
            entryType: "Event",
            event: "Event",
            email: "Event's Email",
            eventBy: "Event by",
            whoIsGoing: "Who is going",
            chooseAtLeastOneStyle: "Please choose at least one style",
            notFound: "Oops! Event not found!",
            latestEvents: "Latest Events",
            likedEvents: "Liked Events",
            deletePrompt: "Are you sure you want to delete the event titled",
            flagPrompt: "Are you sure you want to flag this event?",
            createYourOwn: "You can create your new event here",
            matching: "Matching Events",
            recurringEvent: "Recurring Event",
            noEventsFound: "Oops! there are no events in this area!",
            noEventsYetCreate: "There are no events in this area yet. Create your own event now!",
            create: "Create a new Event",
            recurringWeekly: "Weekly",
            recurringMonthly: "Monthly",
            recurringDaily: "Daily",
            duration: "Duration",
            startTime: "Start Time",
            endTime: "End Time",
            endDate: "End Date",
            startDate: "Start Date",
        },
        onboarding: {
            slide1: {
                title: "Welcome to brizup.app!",
                description: "Create your account for free and start dancing today."
            },
            slide2: {
                title: "Learn and Master Dance Moves",
                description: "Find and join local classes and events that match your favorite dance styles."
            },
            slide3: {
                title: "Build Your Dance Profile",
                description: "Showcase your dance skills, connect with fellow dancers, and make your profile stand out."
            },
            slide4: {
                title: "Dance, socialize, and have fun!",
                description: "Create Your Own Dance Community for All Styles, For Every Level."
            },
            slide5: {
                title: "Connect with Fellow Dancers",
                description: "Meet new dance partners and schedule practice sessions easily."
            },
        },
        resetPasswordButtonText: 'Reset Password',
        createCommunityHeader: "Create Community",
        chooseImage: "Choose an image",
        changeImage: "Change image",
        titleLabel: "Title",
        descriptionLabel: "Description",
        countryLabel: "Country",
        cityLabel: "City",
        submitButton: "Submit",
        latestCommunitiesHeader: "Latest Communities",
        noCommunitiesMessage: "Oops! There are no communities in this region!",
        createCommunityPrompt: "You can create your community here",
        newCommunityButton: "New Community",
        calendarHeader: "Calendar",
        calendarDescription: "The calendar shows the events that are associated with the people you follow and your location.",
        loadingMessage: "Loading...",
        signUpPageTitle: "Create your new account",
        signInPrompt: "Or sign in by clicking here",
        secureAccountPrompt: "Secure your account with a password!",
        passwordLengthRequirement: "password needs to be from 8 to 32 characters",
        passwordUpperLowerRequirement: "has at least one uppercase, one lowercase",
        passwordNumberRequirement: "has at least one number",
        passwordSpecialCharRequirement: "has at least one special character ! @ # $ % ^ & * -",
        acceptPoliciesPrompt: "Please accept the policies",
        previousButton: "Previous",
        nextButton: "Next",
        resetPasswordPageTitle: "Reset password",
        signUpButtonText: "Create Account",
        loginButtonText: "Login",
        loginInsteadText: "Or login if you already have an account",
        resetPasswordPrompt: "Reset Password",
        namePlaceholder: "Name",
        countryPlaceholder: "Country",
        cityPlaceholder: "City",
        peopleDancingAlt: "People dancing",
        fillRequiredFields: 'Please fill in all the required fields',
        weakPassword: 'Password is not strong enough',
        resetPassworPageTitle: "Reset",
        communityHeader: "Community",
        refrainFromProfanity: "Please refrain from using profanity",
        communityEdit: "Edit Community",
        signInWithGoogleButtonText: "Sign in with Google",
        signUpWithGoogleButtonText: "Sign up with Google",
        signInwithAppleButtonText: "Sign in with Apple",
        signUpWithAppleButtonText: "Sign up with Apple",
    },
    es: {
        appTitle: "¡Step it!",
        appDescription: "Tu creador de comunidad de baile",
        errorPageMessage: "¡Ups! Algo sucedió mientras se cargaba esta página. Inténtalo de nuevo más tarde o haz clic en el botón de inicio.",
        page404Message: "La página que buscas no existe. Haz clic en el botón de inicio para volver a la página principal.",
        title: "Título",
        loadMore: "Cargar más",
        description: "Descripción",
        city: "Ciudad",
        start: "Comienzo",
        country: "País",
        styles: "Estilos",
        address: "Dirección",
        signInButtonText: "Iniciar sesión",
        message: {
            message: "Mensaje",
            header: "Mensajes",
            noMessages: "No hay mensajes"
        },
        back: "Atrás",
        retry: "Reintentar",
        sureQuestion: "¿Estás seguro de que quieres",
        home: "Inicio",
        myName: "Mi nombre",
        sorry: "¡Lo siento!",
        block: "Bloquear",
        unblock: "Desbloquear",
        update: "Actualizar",
        follow: "Seguir",
        unfollow: "Dejar de seguir",
        eventEdit: "Editar evento",
        sendFriendRequest: "Agregar amigo",
        cancelFriendRequest: "Cancelar solicitud",
        acceptFriendRequest: "Aceptar solicitud",
        declineFriendRequest: "Rechazar solicitud",
        removeFriend: "Eliminar amigo",
        pageTitle: 'Iniciar sesión',
        refresh: "Actualizar",
        clearAll: "Limpiar todo",
        send: "Enviar",
        skip: "Saltar",
        next: "Siguiente",
        youLiked: "Te gustó",
        emailPlaceholder: 'Correo electrónico',
        passwordPlaceholder: 'Contraseña',
        resultsWillBeShownHere: "Los resultados se mostrarán aquí...",
        profile: {
            name: "Nombre",
            mobile: "Móvil",
            bio: "Biografía",
            email: "Correo electrónico",
            profileType: "Tipo de perfil",
            logout: "Cerrar sesión",
            deleteAccount: "Eliminar cuenta",
            myProfile: "Mi perfil",
            friends: "Amigos",
            noFriends: "Aún no tienes amigos",
            requestsReceived: "Solicitudes de amistad recibidas",
            requestSent: "Solicitudes de amistad enviadas",
            peopleYouMightKnow: "Personas que podrías conocer",
            noPendingSent: "No hay solicitudes de amistad pendientes enviadas",
            noPendingReceived: "No hay solicitudes de amistad pendientes recibidas",
            noAccess: "¡No se puede acceder a este perfil!",
            noAccessUid: "No se puede encontrar el perfil: Problema con el uid",
            dancer: "Bailarín",
            teacher: "Profesor",
            performer: "Intérprete",
            organiser: "Organizador",
            musician: "Músico",
            notFound: "No se puede encontrar el perfil: Problema con el uid",
            loading: "Cargando perfil...",
            user: "Usuario",
            deleteAccountConfirmation: "¿Estás seguro de que quieres eliminar tu cuenta? Esta acción no se puede deshacer.",
            uploadImageConfirmation: "¿Te gustaría actualizar tu imagen de perfil?"
        },
        interests: {
            select: "Selecciona tus intereses para emparejarte con eventos relevantes.",
            header: "Intereses"
        },
        notifications: {
            header: "Notificaciones",
            youNeedToBeLoggedIn: "¡Necesitas estar conectado para ver tus notificaciones!",
            noNotifications: "¡No hay notificaciones!"
        },
        post: {
            latest: "Últimas publicaciones",
            posts: "Publicaciones",
            leaveComment: "Deja un comentario",
            comment: "Comentario",
            comments: "Comentarios",
            post: "Publicar"
        },
        event: {
            myEvents: "Mis eventos",
            events: "Eventos",
            entryType: "Evento",
            event: "Evento",
            email: "Correo del evento",
            eventBy: "Evento por",
            whoIsGoing: "Quién va",
            chooseAtLeastOneStyle: "Por favor, elige al menos un estilo",
            notFound: "¡Ups! Evento no encontrado!",
            latestEvents: "Últimos eventos",
            likedEvents: "Eventos que te gustaron",
            deletePrompt: "¿Estás seguro de que quieres eliminar el evento titulado",
            flagPrompt: "¿Estás seguro de que quieres marcar este evento?",
            createYourOwn: "Puedes crear tu nuevo evento aquí",
            matching: "Eventos coincidentes",
            recurringEvent: "Evento recurrente",
            noEventsFound: "¡Ups! no hay eventos en esta área!",
            noEventsYetCreate: "Aún no hay eventos en esta área. ¡Crea tu propio evento ahora!",
            create: "Crear un nuevo evento",
            recurringWeekly: "Semanal",
            recurringMonthly: "Mensual",
            recurringDaily: "Diario",
            duration: "Duración",
            startTime: "Hora de inicio",
            endTime: "Hora de finalización",
            endDate: "Fecha de finalización",
            startDate: "Fecha de inicio",
        },
        onboarding: {
            slide1: {
                title: "Bienvenido a brizup.app. ¡Es gratis!",
                description: "Crea tu cuenta gratis y comienza a bailar hoy."
            },
            slide2: {
                title: "Aprende y domina movimientos de baile",
                description: "Encuentra y únete a clases y eventos locales que coincidan con tus estilos de baile favoritos."
            },
            slide3: {
                title: "Construye tu perfil de baile",
                description: "Muestra tus habilidades de baile, conéctate con otros bailarines y haz que tu perfil destaque."
            },
            slide4: {
                title: "Baila, socializa y diviértete!",
                description: "Crea tu propia comunidad de baile para todos los estilos, para todos los niveles."
            },
            slide5: {
                title: "Conéctate con otros bailarines",
                description: "Conoce nuevos compañeros de baile y programa sesiones de práctica fácilmente."
            },
        },
        resetPasswordButtonText: 'Restablecer contraseña',
        createCommunityHeader: "Crear comunidad",
        chooseImage: "Elige una imagen",
        changeImage: "Cambiar imagen",
        titleLabel: "Título",
        descriptionLabel: "Descripción",
        countryLabel: "País",
        cityLabel: "Ciudad",
        submitButton: "Enviar",
        latestCommunitiesHeader: "Últimas comunidades",
        noCommunitiesMessage: "¡Ups! No hay comunidades en esta región!",
        createCommunityPrompt: "Puedes crear tu comunidad aquí",
        newCommunityButton: "Nueva comunidad",
        calendarHeader: "Calendario",
        calendarDescription: "El calendario muestra los eventos que están asociados con las personas que sigues y tu ubicación.",
        loadingMessage: "Cargando...",
        signUpPageTitle: "¡Crea tu nueva cuenta gratis! 😊",
        signInPrompt: "O inicia sesión haciendo clic aquí",
        secureAccountPrompt: "¡Asegura tu cuenta con una contraseña!",
        passwordLengthRequirement: "la contraseña debe tener entre 8 y 32 caracteres",
        passwordUpperLowerRequirement: "tener al menos una mayúscula, una minúscula",
        passwordNumberRequirement: "tener al menos un número",
        passwordSpecialCharRequirement: "tener al menos un carácter especial ! @ # $ % ^ & * -",
        acceptPoliciesPrompt: "Por favor, acepta las políticas",
        previousButton: "Anterior",
        nextButton: "Siguiente",
        resetPasswordPageTitle: "Restablecer contraseña",
        signUpButtonText: "Registrarse",
        loginButtonText: "Iniciar sesión",
        resetPasswordPrompt: "Restablecer contraseña",
        namePlaceholder: "Nombre",
        countryPlaceholder: "País",
        cityPlaceholder: "Ciudad",
        peopleDancingAlt: "Personas bailando",
        fillRequiredFields: 'Por favor, completa todos los campos obligatorios',
        weakPassword: 'La contraseña no es lo suficientemente fuerte',
        resetPassworPageTitle: "Restablecer",
        communityHeader: "Comunidad",
        refrainFromProfanity: "Por favor, evita usar palabras malsonantes",
        communityEdit: "Editar comunidad",
        signInWithGoogleButtonText: "Iniciar sesión con Google",
        signUpWithGoogleButtonText: "Registrarse con Google",
        signInwithAppleButtonText: "Iniciar sesión con Apple",
        signUpWithAppleButtonText: "Registrarse con Apple",
        loginInsteadText: "Si ya tienes una cuenta, inicia sesión aquí",
    },
    fr: {
        appTitle: "Step it!",
        appDescription: "Votre créateur de communauté de danse",
        errorPageMessage: "Oups! Quelque chose s'est passé lors du chargement de cette page. Réessayez plus tard ou cliquez sur le bouton d'accueil.",
        page404Message: "La page que vous recherchez n'existe pas. Cliquez sur le bouton d'accueil pour revenir à la page principale.",
        title: "Titre",
        loadMore: "Charger plus",
        description: "Description",
        city: "Ville",
        country: "Pays",
        styles: "Styles",
        address: "Adresse",
        signInButtonText: "Se connecter",
        message: {
            message: "Message",
            header: "Messages",
            noMessages: "Pas de messages"
        },
        back: "Retour",
        retry: "Réessayer",
        sureQuestion: "Êtes-vous sûr de vouloir",
        home: "Accueil",
        start: "Début",
        myName: "Mon nom",
        sorry: "Désolé!",
        block: "Bloquer",
        unblock: "Débloquer",
        update: "Mettre à jour",
        follow: "Suivre",
        unfollow: "Ne plus suivre",
        eventEdit: "Modifier l'événement",
        sendFriendRequest: "Ajouter un ami",
        cancelFriendRequest: "Annuler la demande",
        acceptFriendRequest: "Accepter la demande",
        declineFriendRequest: "Refuser la demande",
        removeFriend: "Supprimer l'ami",
        pageTitle: 'Se connecter',
        refresh: "Rafraîchir",
        clearAll: "Tout effacer",
        send: "Envoyer",
        skip: "Passer",
        next: "Suivant",
        youLiked: "Vous avez aimé",
        emailPlaceholder: 'Email',
        passwordPlaceholder: 'Mot de passe',
        resultsWillBeShownHere: "Les résultats seront affichés ici...",
        profile: {
            name: "Nom",
            mobile: "Mobile",
            bio: "Bio",
            email: "Email",
            profileType: "Type de profil",
            logout: "Déconnexion",
            deleteAccount: "Supprimer le compte",
            myProfile: "Mon profil",
            friends: "Amis",
            noFriends: "Vous n'avez pas encore d'amis",
            requestsReceived: "Demandes d'amis reçues",
            requestSent: "Demandes d'amis envoyées",
            peopleYouMightKnow: "Personnes que vous pourriez connaître",
            noPendingSent: "Aucune demande d'ami en attente envoyée",
            noPendingReceived: "Aucune demande d'ami en attente reçue",
            noAccess: "Impossible d'accéder à ce profil!",
            noAccessUid: "Impossible de trouver le profil: Problème avec l'uid",
            dancer: "Danseur",
            teacher: "Professeur",
            performer: "Interprète",
            organiser: "Organisateur",
            musician: "Musicien",
            notFound: "Impossible de trouver le profil: Problème avec l'uid",
            loading: "Chargement du profil...",
            user: "Utilisateur",
            deleteAccountConfirmation: "Êtes-vous sûr de vouloir supprimer votre compte? Cette action ne peut pas être annulée.",
            uploadImageConfirmation: "Voulez-vous mettre à jour votre image de profil?"
        },
        interests: {
            select: "Sélectionnez vos intérêts pour vous associer à des événements pertinents.",
            header: "Intérêts"
        },
        notifications: {
            header: "Notifications",
            youNeedToBeLoggedIn: "Vous devez être connecté pour voir vos notifications!",
            noNotifications: "Il n'y a pas de notifications!"
        },
        post: {
            latest: "Derniers messages",
            posts: "Messages",
            leaveComment: "Laisser un commentaire",
            comment: "Commentaire",
            comments: "Commentaires",
            post: "Message"
        },
        event: {
            myEvents: "Mes événements",
            events: "Événements",
            entryType: "Événement",
            event: "Événement",
            email: "Email de l'événement",
            eventBy: "Événement par",
            whoIsGoing: "Qui va",
            chooseAtLeastOneStyle: "Veuillez choisir au moins un style",
            notFound: "Oups! Événement non trouvé!",
            latestEvents: "Derniers événements",
            likedEvents: "Événements aimés",
            deletePrompt: "Êtes-vous sûr de vouloir supprimer l'événement intitulé",
            flagPrompt: "Êtes-vous sûr de vouloir signaler cet événement?",
            createYourOwn: "Vous pouvez créer votre nouvel événement ici",
            matching: "Événements correspondants",
            recurringEvent: "Événement récurrent",
            noEventsFound: "Oups! il n'y a pas d'événements dans cette région!",
            noEventsYetCreate: "Il n'y a pas encore d'événements dans cette région. Créez votre propre événement maintenant!",
            create: "Créer un nouvel événement",
            recurringWeekly: "Hebdomadaire",
            recurringMonthly: "Mensuel",
            recurringDaily: "Quotidien",
            duration: "Durée",
            startTime: "Heure de début",
            endTime: "Heure de fin",
            endDate: "Date de fin",
            startDate: "Date de début",
        },
        onboarding: {
            slide1: {
                title: "Bienvenue sur brizup.app. C'est gratuit!",
                description: "Créez votre compte gratuitement et commencez à danser dès aujourd'hui."
            },
            slide2: {
                title: "Apprenez et maîtrisez les mouvements de danse",
                description: "Trouvez et rejoignez des cours et des événements locaux qui correspondent à vos styles de danse préférés."
            },
            slide3: {
                title: "Construisez votre profil de danse",
                description: "Montrez vos compétences en danse, connectez-vous avec d'autres danseurs et faites ressortir votre profil."
            },
            slide4: {
                title: "Dansez, socialisez et amusez-vous!",
                description: "Créez votre propre communauté de danse pour tous les styles, pour tous les niveaux."
            },
            slide5: {
                title: "Connectez-vous avec d'autres danseurs",
                description: "Rencontrez de nouveaux partenaires de danse et planifiez facilement des sessions de pratique."
            },
        },
        resetPasswordButtonText: 'Réinitialiser le mot de passe',
        createCommunityHeader: "Créer une communauté",
        chooseImage: "Choisir une image",
        changeImage: "Changer l'image",
        titleLabel: "Titre",
        descriptionLabel: "Description",
        countryLabel: "Pays",
        cityLabel: "Ville",
        submitButton: "Soumettre",
        latestCommunitiesHeader: "Dernières communautés",
        noCommunitiesMessage: "Oups! Il n'y a pas de communautés dans cette région!",
        createCommunityPrompt: "Vous pouvez créer votre communauté ici",
        newCommunityButton: "Nouvelle communauté",
        calendarHeader: "Calendrier",
        calendarDescription: "Le calendrier montre les événements associés aux personnes que vous suivez et à votre emplacement.",
        loadingMessage: "Chargement...",
        signUpPageTitle: "Créez votre nouveau compte gratuitement! 😊",
        signInPrompt: "Ou connectez-vous en cliquant ici",
        secureAccountPrompt: "Sécurisez votre compte avec un mot de passe!",
        passwordLengthRequirement: "le mot de passe doit comporter de 8 à 32 caractères",
        passwordUpperLowerRequirement: "avoir au moins une majuscule, une minuscule",
        passwordNumberRequirement: "avoir au moins un chiffre",
        passwordSpecialCharRequirement: "avoir au moins un caractère spécial ! @ # $ % ^ & * -",
        acceptPoliciesPrompt: "Veuillez accepter les politiques",
        previousButton: "Précédent",
        nextButton: "Suivant",
        resetPasswordPageTitle: "Réinitialiser le mot de passe",
        signUpButtonText: "S'inscrire",
        loginButtonText: "Connexion",
        resetPasswordPrompt: "Réinitialiser le mot de passe",
        namePlaceholder: "Nom",
        countryPlaceholder: "Pays",
        cityPlaceholder: "Ville",
        peopleDancingAlt: "Personnes dansant",
        fillRequiredFields: 'Veuillez remplir tous les champs obligatoires',
        weakPassword: 'Le mot de passe n`est pas assez fort',
        resetPassworPageTitle: "Réinitialiser",
        communityHeader: "Communauté",
        refrainFromProfanity: "Veuillez éviter d'utiliser des grossièretés",
        communityEdit: "Modifier la communauté",
        signInWithGoogleButtonText: "Se connecter avec Google",
        signUpWithGoogleButtonText: "S'inscrire avec Google",
        signInwithAppleButtonText: "Se connecter avec Apple",
        signUpWithAppleButtonText: "S'inscrire avec Apple",
        loginInsteadText: "Si vous avez déjà un compte, connectez-vous ici",
    },
    pt: {
        appTitle: "Step it!",
        appDescription: "Seu criador de comunidade de dança",
        errorPageMessage: "Ops! Algo aconteceu ao carregar esta página. Tente novamente mais tarde ou clique no botão de início.",
        page404Message: "A página que você está procurando não existe. Clique no botão de início para voltar à página principal.",
        title: "Título",
        loadMore: "Carregar mais",
        description: "Descrição",
        city: "Cidade",
        country: "País",
        start: "Início",
        styles: "Estilos",
        signInButtonText: "Entrar",
        address: "Endereço",
        message: {
            message: "Mensagem",
            header: "Mensagens",
            noMessages: "Sem mensagens"
        },
        back: "Voltar",
        retry: "Tentar novamente",
        sureQuestion: "Você tem certeza de que deseja",
        home: "Início",
        myName: "Meu nome",
        sorry: "Desculpe!",
        block: "Bloquear",
        unblock: "Desbloquear",
        update: "Atualizar",
        follow: "Seguir",
        unfollow: "Deixar de seguir",
        eventEdit: "Editar evento",
        sendFriendRequest: "Adicionar amigo",
        cancelFriendRequest: "Cancelar solicitação",
        acceptFriendRequest: "Aceitar solicitação",
        declineFriendRequest: "Recusar solicitação",
        removeFriend: "Remover amigo",
        pageTitle: 'Entrar',
        refresh: "Atualizar",
        clearAll: "Limpar tudo",
        send: "Enviar",
        skip: "Pular",
        next: "Próximo",
        youLiked: "Você gostou",
        emailPlaceholder: 'Email',
        passwordPlaceholder: 'Senha',
        resultsWillBeShownHere: "Os resultados serão mostrados aqui...",
        profile: {
            name: "Nome",
            mobile: "Celular",
            bio: "Bio",
            email: "Email",
            profileType: "Tipo de perfil",
            logout: "Sair",
            deleteAccount: "Excluir conta",
            myProfile: "Meu perfil",
            friends: "Amigos",
            noFriends: "Você ainda não tem amigos",
            requestsReceived: "Solicitações de amizade recebidas",
            requestSent: "Solicitações de amizade enviadas",
            peopleYouMightKnow: "Pessoas que você pode conhecer",
            noPendingSent: "Nenhuma solicitação de amizade pendente enviada",
            noPendingReceived: "Nenhuma solicitação de amizade pendente recebida",
            noAccess: "Não é possível acessar este perfil!",
            noAccessUid: "Não é possível encontrar o perfil: Problema com o uid",
            dancer: "Dançarino",
            teacher: "Professor",
            performer: "Intérprete",
            organiser: "Organizador",
            musician: "Músico",
            notFound: "Não é possível encontrar o perfil: Problema com o uid",
            loading: "Carregando perfil...",
            user: "Usuário",
            deleteAccountConfirmation: "Você tem certeza de que deseja excluir sua conta? Esta ação não pode ser desfeita.",
            uploadImageConfirmation: "Você gostaria de atualizar sua imagem de perfil?"
        },
        interests: {
            select: "Selecione seus interesses para combiná-lo com eventos relevantes.",
            header: "Interesses"
        },
        notifications: {
            header: "Notificações",
            youNeedToBeLoggedIn: "Você precisa estar logado para ver suas notificações!",
            noNotifications: "Não há notificações!"
        },
        post: {
            latest: "Últimas postagens",
            posts: "Postagens",
            leaveComment: "Deixe um comentário",
            comment: "Comentário",
            comments: "Comentários",
            post: "Postar"
        },
        event: {
            myEvents: "Meus eventos",
            events: "Eventos",
            entryType: "Evento",
            event: "Evento",
            email: "Email do evento",
            eventBy: "Evento por",
            whoIsGoing: "Quem vai",
            chooseAtLeastOneStyle: "Por favor, escolha pelo menos um estilo",
            notFound: "Ops! Evento não encontrado!",
            latestEvents: "Últimos eventos",
            likedEvents: "Eventos curtidos",
            deletePrompt: "Você tem certeza de que deseja excluir o evento intitulado",
            flagPrompt: "Você tem certeza de que deseja sinalizar este evento?",
            createYourOwn: "Você pode criar seu novo evento aqui",
            matching: "Eventos correspondentes",
            recurringEvent: "Evento recorrente",
            noEventsFound: "Ops! não há eventos nesta área!",
            noEventsYetCreate: "Ainda não há eventos nesta área. Crie seu próprio evento agora!",
            create: "Criar um novo evento",
            recurringWeekly: "Semanal",
            recurringMonthly: "Mensal",
            recurringDaily: "Diário",
            duration: "Duração",
            startTime: "Hora de início",
            endTime: "Hora de término",
            endDate: "Data de término",
            startDate: "Data de início",
        },
        onboarding: {
            slide1: {
                title: "Bem-vindo ao brizup.app. É grátis!",
                description: "Crie sua conta gratuitamente e comece a dançar hoje."
            },
            slide2: {
                title: "Aprenda e domine movimentos de dança",
                description: "Encontre e participe de aulas e eventos locais que correspondam aos seus estilos de dança favoritos."
            },
            slide3: {
                title: "Construa seu perfil de dança",
                description: "Mostre suas habilidades de dança, conecte-se com outros dançarinos e faça seu perfil se destacar."
            },
            slide4: {
                title: "Dance, socialize e divirta-se!",
                description: "Crie sua própria comunidade de dança para todos os estilos, para todos os níveis."
            },
            slide5: {
                title: "Conecte-se com outros dançarinos",
                description: "Conheça novos parceiros de dança e agende sessões de prática facilmente."
            },
        },
        resetPasswordButtonText: 'Redefinir senha',
        createCommunityHeader: "Criar comunidade",
        chooseImage: "Escolha uma imagem",
        changeImage: "Mudar imagem",
        titleLabel: "Título",
        descriptionLabel: "Descrição",
        countryLabel: "País",
        cityLabel: "Cidade",
        submitButton: "Enviar",
        latestCommunitiesHeader: "Últimas comunidades",
        noCommunitiesMessage: "Ops! Não há comunidades nesta região!",
        createCommunityPrompt: "Você pode criar sua comunidade aqui",
        newCommunityButton: "Nova comunidade",
        calendarHeader: "Calendário",
        calendarDescription: "O calendário mostra os eventos que estão associados às pessoas que você segue e sua localização.",
        loadingMessage: "Carregando...",
        signUpPageTitle: "Crie sua nova conta gratuitamente! 😊",
        signInPrompt: "Ou faça login clicando aqui",
        secureAccountPrompt: "Proteja sua conta com uma senha!",
        passwordLengthRequirement: "a senha deve ter de 8 a 32 caracteres",
        passwordUpperLowerRequirement: "ter pelo menos uma maiúscula, uma minúscula",
        passwordNumberRequirement: "ter pelo menos um número",
        passwordSpecialCharRequirement: "ter pelo menos um caractere especial ! @ # $ % ^ & * -",
        acceptPoliciesPrompt: "Por favor, aceite as políticas",
        previousButton: "Anterior",
        nextButton: "Próximo",
        resetPasswordPageTitle: "Redefinir senha",
        signUpButtonText: "Inscrever-se",
        loginButtonText: "Entrar",
        resetPasswordPrompt: "Redefinir senha",
        namePlaceholder: "Nome",
        countryPlaceholder: "País",
        cityPlaceholder: "Cidade",
        peopleDancingAlt: "Pessoas dançando",
        fillRequiredFields: 'Por favor, preencha todos os campos obrigatórios',
        weakPassword: 'A senha não é forte o suficiente',
        resetPassworPageTitle: "Redefinir",
        communityHeader: "Comunidade",
        refrainFromProfanity: "Por favor, evite usar palavrões",
        communityEdit: "Editar comunidade",
        signInWithGoogleButtonText: "Entrar com o Google",
        signUpWithGoogleButtonText: "Inscrever-se com o Google",
        signInwithAppleButtonText: "Entrar com a Apple",
        signUpWithAppleButtonText: "Inscrever-se com a Apple",
        loginInsteadText: "Se você já tem uma conta, faça login aqui",
    },
    it: {
        appTitle: "Step it!",
        appDescription: "Il tuo creatore di comunità di ballo",
        errorPageMessage: "Ops! Qualcosa è successo durante il caricamento di questa pagina. Riprova più tardi o clicca sul pulsante home.",
        page404Message: "La pagina che stai cercando non esiste. Clicca sul pulsante home per tornare alla pagina principale.",
        title: "Titolo",
        loadMore: "Carica di più",
        description: "Descrizione",
        city: "Città",
        start: "Inizio",
        country: "Paese",
        styles: "Stili",
        signInButtonText: "Accedi",
        address: "Indirizzo",
        message: {
            message: "Messaggio",
            header: "Messaggi",
            noMessages: "Nessun messaggio"
        },
        back: "Indietro",
        retry: "Riprova",
        sureQuestion: "Sei sicuro di voler",
        home: "Home",
        myName: "Il mio nome",
        sorry: "Spiacente!",
        block: "Blocca",
        unblock: "Sblocca",
        update: "Aggiorna",
        follow: "Segui",
        unfollow: "Smetti di seguire",
        eventEdit: "Modifica evento",
        sendFriendRequest: "Aggiungi amico",
        cancelFriendRequest: "Annulla richiesta",
        acceptFriendRequest: "Accetta richiesta",
        declineFriendRequest: "Rifiuta richiesta",
        removeFriend: "Rimuovi amico",
        pageTitle: 'Accedi',
        refresh: "Aggiorna",
        clearAll: "Cancella tutto",
        send: "Invia",
        skip: "Salta",
        next: "Avanti",
        youLiked: "Ti è piaciuto",
        emailPlaceholder: 'Email',
        passwordPlaceholder: 'Password',
        resultsWillBeShownHere: "I risultati verranno mostrati qui...",
        profile: {
            name: "Nome",
            mobile: "Cellulare",
            bio: "Biografia",
            email: "Email",
            profileType: "Tipo di profilo",
            logout: "Esci",
            deleteAccount: "Elimina account",
            myProfile: "Il mio profilo",
            friends: "Amici",
            noFriends: "Non hai ancora amici",
            requestsReceived: "Richieste di amicizia ricevute",
            requestSent: "Richieste di amicizia inviate",
            peopleYouMightKnow: "Persone che potresti conoscere",
            noPendingSent: "Nessuna richiesta di amicizia in sospeso inviata",
            noPendingReceived: "Nessuna richiesta di amicizia in sospeso ricevuta",
            noAccess: "Impossibile accedere a questo profilo!",
            noAccessUid: "Impossibile trovare il profilo: Problema con l'uid",
            dancer: "Ballerino",
            teacher: "Insegnante",
            performer: "Interprete",
            organiser: "Organizzatore",
            musician: "Musicista",
            notFound: "Impossibile trovare il profilo: Problema con l'uid",
            loading: "Caricamento profilo...",
            user: "Utente",
            deleteAccountConfirmation: "Sei sicuro di voler eliminare il tuo account? Questa azione non può essere annullata.",
            uploadImageConfirmation: "Vuoi aggiornare la tua immagine del profilo?"
        },
        interests: {
            select: "Seleziona i tuoi interessi per abbinarli a eventi rilevanti.",
            header: "Interessi"
        },
        notifications: {
            header: "Notifiche",
            youNeedToBeLoggedIn: "Devi essere loggato per vedere le tue notifiche!",
            noNotifications: "Non ci sono notifiche!"
        },
        post: {
            latest: "Ultimi post",
            posts: "Post",
            leaveComment: "Lascia un commento",
            comment: "Commento",
            comments: "Commenti",
            post: "Posta"
        },
        event: {
            myEvents: "I miei eventi",
            events: "Eventi",
            entryType: "Evento",
            event: "Evento",
            email: "Email dell'evento",
            eventBy: "Evento di",
            whoIsGoing: "Chi va",
            chooseAtLeastOneStyle: "Per favore, scegli almeno uno stile",
            notFound: "Ops! Evento non trovato!",
            latestEvents: "Ultimi eventi",
            likedEvents: "Eventi piaciuti",
            deletePrompt: "Sei sicuro di voler eliminare l'evento intitolato",
            flagPrompt: "Sei sicuro di voler segnalare questo evento?",
            createYourOwn: "Puoi creare il tuo nuovo evento qui",
            matching: "Eventi corrispondenti",
            recurringEvent: "Evento ricorrente",
            noEventsFound: "Ops! non ci sono eventi in questa area!",
            noEventsYetCreate: "Non ci sono ancora eventi in questa area. Crea il tuo evento ora!",
            create: "Crea un nuovo evento",
            recurringWeekly: "Settimanale",
            recurringMonthly: "Mensile",
            recurringDaily: "Giornaliero",
            duration: "Durata",
            startTime: "Ora di inizio",
            endTime: "Ora di fine",
            endDate: "Data di fine",
            startDate: "Data di inizio",
        },
        onboarding: {
            slide1: {
                title: "Benvenuto su brizup.app. È gratis!",
                description: "Crea il tuo account gratuitamente e inizia a ballare oggi."
            },
            slide2: {
                title: "Impara e padroneggia i movimenti di danza",
                description: "Trova e partecipa a lezioni ed eventi locali che corrispondono ai tuoi stili di danza preferiti."
            },
            slide3: {
                title: "Costruisci il tuo profilo di danza",
                description: "Mostra le tue abilità di danza, connettiti con altri ballerini e fai risaltare il tuo profilo."
            },
            slide4: {
                title: "Balla, socializza e divertiti!",
                description: "Crea la tua comunità di danza per tutti gli stili, per ogni livello."
            },
            slide5: {
                title: "Connettiti con altri ballerini",
                description: "Incontra nuovi partner di danza e programma facilmente sessioni di pratica."
            },
        },
        resetPasswordButtonText: 'Reimposta password',
        createCommunityHeader: "Crea comunità",
        chooseImage: "Scegli un'immagine",
        changeImage: "Cambia immagine",
        titleLabel: "Titolo",
        descriptionLabel: "Descrizione",
        countryLabel: "Paese",
        cityLabel: "Città",
        submitButton: "Invia",
        latestCommunitiesHeader: "Ultime comunità",
        noCommunitiesMessage: "Ops! Non ci sono comunità in questa regione!",
        createCommunityPrompt: "Puoi creare la tua comunità qui",
        newCommunityButton: "Nuova comunità",
        calendarHeader: "Calendario",
        calendarDescription: "Il calendario mostra gli eventi associati alle persone che segui e alla tua posizione.",
        loadingMessage: "Caricamento...",
        signUpPageTitle: "Crea il tuo nuovo account gratuitamente! 😊",
        signInPrompt: "O accedi cliccando qui",
        secureAccountPrompt: "Proteggi il tuo account con una password!",
        passwordLengthRequirement: "la password deve essere da 8 a 32 caratteri",
        passwordUpperLowerRequirement: "avere almeno una maiuscola, una minuscola",
        passwordNumberRequirement: "avere almeno un numero",
        passwordSpecialCharRequirement: "avere almeno un carattere speciale ! @ # $ % ^ & * -",
        acceptPoliciesPrompt: "Per favore, accetta le politiche",
        previousButton: "Precedente",
        nextButton: "Successivo",
        resetPasswordPageTitle: "Reimposta password",
        signUpButtonText: "Iscriviti",
        loginButtonText: "Accedi",
        resetPasswordPrompt: "Reimposta password",
        namePlaceholder: "Nome",
        countryPlaceholder: "Paese",
        cityPlaceholder: "Città",
        peopleDancingAlt: "Persone che ballano",
        fillRequiredFields: 'Per favore, compila tutti i campi obbligatori',
        weakPassword: 'La password non è abbastanza forte',
        resetPassworPageTitle: "Reimposta",
        communityHeader: "Comunità",
        refrainFromProfanity: "Per favore, evita di usare parolacce",
        communityEdit: "Modifica comunità",
        signInWithGoogleButtonText: "Accedi con Google",
        signUpWithGoogleButtonText: "Iscriviti con Google",
        signInwithAppleButtonText: "Accedi con Apple",
        signUpWithAppleButtonText: "Iscriviti con Apple",
        loginInsteadText: "Se hai già un account, accedi qui",
    },
    pl: {
        appTitle: "Step it!",
        appDescription: "Twój kreator społeczności tanecznej",
        errorPageMessage: "Ups! Coś poszło nie tak podczas ładowania tej strony. Spróbuj ponownie później lub kliknij przycisk start.",
        page404Message: "Strona, której szukasz, nie istnieje. Kliknij przycisk start, aby wrócić do strony głównej.",
        title: "Tytuł",
        loadMore: "Załaduj więcej",
        description: "Opis",
        city: "Miasto",
        country: "Kraj",
        start: "Początek",
        styles: "Style",
        signInButtonText: "Zaloguj się",
        address: "Adres",
        message: {
            message: "Wiadomość",
            header: "Wiadomości",
            noMessages: "Brak wiadomości"
        },
        back: "Powrót",
        retry: "Ponów",
        sureQuestion: "Jesteś pewien, że chcesz",
        home: "Strona główna",
        myName: "Moje imię",
        sorry: "Przepraszam!",
        block: "Zablokuj",
        unblock: "Odblokuj",
        update: "Aktualizuj",
        follow: "Śledź",
        unfollow: "Przestań śledzić",
        eventEdit: "Edytuj wydarzenie",
        sendFriendRequest: "Dodaj przyjaciela",
        cancelFriendRequest: "Anuluj prośbę",
        acceptFriendRequest: "Akceptuj prośbę",
        declineFriendRequest: "Odrzuć prośbę",
        removeFriend: "Usuń przyjaciela",
        pageTitle: 'Zaloguj się',
        refresh: "Odśwież",
        clearAll: "Wyczyść wszystko",
        send: "Wyślij",
        skip: "Pomiń",
        next: "Następny",
        youLiked: "Spodobało ci się",
        emailPlaceholder: 'Email',
        passwordPlaceholder: 'Hasło',
        resultsWillBeShownHere: "Wyniki zostaną tutaj pokazane...",
        profile: {
            name: "Imię",
            mobile: "Telefon komórkowy",
            bio: "Bio",
            email: "Email",
            profileType: "Typ profilu",
            logout: "Wyloguj się",
            deleteAccount: "Usuń konto",
            myProfile: "Mój profil",
            friends: "Przyjaciele",
            noFriends: "Nie masz jeszcze przyjaciół",
            requestsReceived: "Otrzymane prośby",
            requestSent: "Wysłane prośby",
            peopleYouMightKnow: "Osoby, które możesz znać",
            noPendingSent: "Brak oczekujących wysłanych prośb",
            noPendingReceived: "Brak oczekujących otrzymanych prośb",
            noAccess: "Nie można uzyskać dostępu do tego profilu!",
            noAccessUid: "Nie można znaleźć profilu: Problem z uid",
            dancer: "Tancerz",
            teacher: "Nauczyciel",
            performer: "Wykonawca",
            organiser: "Organizator",
            musician: "Muzyk",
            notFound: "Nie można znaleźć profilu: Problem z uid",
            loading: "Ładowanie profilu...",
            user: "Użytkownik",
            deleteAccountConfirmation: "Jesteś pewien, że chcesz usunąć swoje konto? Tej akcji nie można cofnąć.",
            uploadImageConfirmation: "Czy chcesz zaktualizować swoje zdjęcie profilowe?"
        },
        interests: {
            select: "Wybierz swoje zainteresowania, aby dopasować je do odpowiednich wydarzeń.",
            header: "Zainteresowania"
        },
        notifications: {
            header: "Powiadomienia",
            youNeedToBeLoggedIn: "Musisz być zalogowany, aby zobaczyć swoje powiadomienia!",
            noNotifications: "Brak powiadomień!"
        },
        post: {
            latest: "Ostatnie posty",
            posts: "Posty",
            leaveComment: "Zostaw komentarz",
            comment: "Komentarz",
            comments: "Komentarze",
            post: "Post"
        },
        event: {
            myEvents: "Moje wydarzenia",
            events: "Wydarzenia",
            entryType: "Wydarzenie",
            event: "Wydarzenie",
            email: "Email wydarzenia",
            eventBy: "Wydarzenie przez",
            whoIsGoing: "Kto idzie",
            chooseAtLeastOneStyle: "Wybierz co najmniej jeden styl",
            notFound: "Ups! Wydarzenie nie znalezione!",
            latestEvents: "Najnowsze wydarzenia",
            likedEvents: "Polubione wydarzenia",
            deletePrompt: "Jesteś pewien, że chcesz usunąć wydarzenie o nazwie",
            flagPrompt: "Jesteś pewien, że chcesz zgłosić to wydarzenie?",
            createYourOwn: "Możesz utworzyć swoje nowe wydarzenie tutaj",
            matching: "Pasujące wydarzenia",
            recurringEvent: "Wydarzenie cykliczne",
            noEventsFound: "Ups! nie ma wydarzeń w tym obszarze!",
            noEventsYetCreate: "W tym obszarze nie ma jeszcze wydarzeń. Utwórz swoje własne wydarzenie teraz!",
            create: "Utwórz nowe wydarzenie",
            recurringWeekly: "Tygodniowo",
            recurringMonthly: "Miesięcznie",
            recurringDaily: "Codziennie",
            duration: "Czas trwania",
            startTime: "Czas rozpoczęcia",
            endTime: "Czas zakończenia",
            endDate: "Data zakończenia",
            startDate: "Data rozpoczęcia",
        },
        onboarding: {
            slide1: {
                title: "Witaj w brizup.app. Jest za darmo!",
                description: "Załóż konto za darmo i zacznij tańczyć już dziś."
            },
            slide2: {
                title: "Naucz się i opanuj ruchy taneczne",
                description: "Znajdź i dołącz do lokalnych zajęć i wydarzeń, które odpowiadają Twoim ulubionym stylom tańca."
            },
            slide3: {
                title: "Stwórz swój profil taneczny",
                description: "Pokaż swoje umiejętności taneczne, połącz się z innymi tancerzami i wyróżnij swój profil."
            },
            slide4: {
                title: "Taniec, socializacja i zabawa!",
                description: "Stwórz swoją własną społeczność taneczną dla wszystkich stylów, dla wszystkich poziomów."
            },
            slide5: {
                title: "Połącz się z innymi tancerzami",
                description: "Poznaj nowych partnerów tanecznych i łatwo planuj sesje praktyki."
            },
        },
        resetPasswordButtonText: 'Zresetuj hasło',
        createCommunityHeader: "Utwórz społeczność",
        chooseImage: "Wybierz obraz",
        changeImage: "Zmień obraz",
        titleLabel: "Tytuł",
        descriptionLabel: "Opis",
        countryLabel: "Kraj",
        cityLabel: "Miasto",
        submitButton: "Wyślij",
        latestCommunitiesHeader: "Ostatnie społeczności",
        noCommunitiesMessage: "Ups! W tej okolicy nie ma społeczności!",
        createCommunityPrompt: "Możesz utworzyć swoją społeczność tutaj",
        newCommunityButton: "Nowa społeczność",
        calendarHeader: "Kalendarz",
        calendarDescription: "Kalendarz pokazuje wydarzenia związane z osobami, które śledzisz, i Twoją lokalizacją.",
        loadingMessage: "Ładowanie...",
        signUpPageTitle: "Utwórz swoje nowe konto za darmo! 😊",
        signInPrompt: "Lub zaloguj się, klikając tutaj",
        secureAccountPrompt: "Zabezpiecz swoje konto hasłem!",
        passwordLengthRequirement: "hasło musi mieć od 8 do 32 znaków",
        passwordUpperLowerRequirement: "mieć co najmniej jedną dużą literę, jedną małą literę",
        passwordNumberRequirement: "mieć co najmniej jedną cyfrę",
        passwordSpecialCharRequirement: "mieć co najmniej jeden znak specjalny ! @ # $ % ^ & * -",
        acceptPoliciesPrompt: "Proszę zaakceptuj polityki",
        previousButton: "Poprzedni",
        nextButton: "Następny",
        resetPasswordPageTitle: "Resetuj hasło",
        signUpButtonText: "Zapisz się",
        loginButtonText: "Zaloguj się",
        resetPasswordPrompt: "Resetuj hasło",
        namePlaceholder: "Imię",
        countryPlaceholder: "Kraj",
        cityPlaceholder: "Miasto",
        peopleDancingAlt: "Ludzie tańczący",
        fillRequiredFields: 'Proszę wypełnić wszystkie wymagane pola',
        communityHeader: "Społeczność",
        signInWithGoogleButtonText: "Zaloguj się za pomocą Google",
        signUpWithGoogleButtonText: "Zapisz się za pomocą Google",
        signInwithAppleButtonText: "Zaloguj się za pomocą Apple",
        signUpWithAppleButtonText: "Zapisz się za pomocą Apple",
        weakPassword: 'Hasło jest zbyt słabe',
        resetPassworPageTitle: "Resetuj",
        refrainFromProfanity: "Proszę powstrzymaj się od przekleństw",
        communityEdit: "Edytuj społeczność",
        loginInsteadText: "Jeśli masz już konto, zaloguj się tutaj",
    }
};

export const localeTexts = texts[lang];